<template>
  <div :class="['global-auth-box d-flex justify-center align-center', {hide:!show}]" @click="show = false">
    <div class="g-auth-box" @click.stop>
      <div class="back-box">
        <span @click="showGlobalLogin">
          <i class="fas fa-chevron-left fa-fw"></i>
          Login
        </span>
      </div>
      <div class="select-txt">Select an account type</div>
      <div class="d-flex justify-space-between">
        <div class="box-type" @click="showSignup">
          <i class="fas fa-user fa-3x fa-fw"></i>
          <div>Regular Account</div>
        </div>
        <div class="box-type" @click="showCorporate">
          <i class="fas fa-user-tie fa-3x fa-fw"></i>
          <div>Corporate Account</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'auth-signup-select',
  computed: {
    auth () { return this.$store.state.global.auth },
    show: {
      get () { return this.$store.state.global.auth.signupSelect },
      set (x) {
        if (this.auth.action === 'forceAuth') return
        this.$store.commit('global/setAuthData', {signupSelect: x})
      }
    }
  },
  methods: {
    showGlobalLogin () {
      this.$store.commit('global/setAuthData', {
        show: true,
        signupSelect: false
      })
    },
    showSignup () {
      if (this.$route.name === 'D2DReview') {
        this.$store.commit('booking/setOthersData', {reviewAction: 'signup'})
        return
      }

      this.$store.commit('global/setAuthData', {
        signupSelect: false,
        showSignup: true
      })
    },
    showCorporate () {
      this.$store.commit('global/setAuthData', {
        signupSelect: false,
        showCorporate: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.global-auth-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;

  .g-auth-box{
    background: #f9f9f9;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgba(0,0,0, .3);
    padding: 30px;
    width: 100%;
    max-width: 360px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  &.hide {
    z-index: -1;
    opacity: 0;
    display: none !important;

    .g-auth-box{
      transform: scale(40%) translateY(30px);
    }
  }
}
.back-box{
  margin-bottom: 30px;
  color: #708193;

  i{
    color: #a7b9cb;
    vertical-align: -1px;
  }
  span{
    cursor: pointer;
    &:hover *{
      color: #2c3e50;
    }
  }
}
.select-txt{
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: .7px;
  margin-bottom: 15px;
  line-height: 1;
}
.box-type{
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  background: #f7f7f7;
  color: #62778b;

  &:hover{
    color: #2c3e50;
    background: #fff;
  }
  i{
    margin-bottom: 8px;
    line-height: 1;
  }
  div{
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: .6px;
  }
}
</style>



// WEBPACK FOOTER //
// GlobalSignupSelect.vue?4dd7572f